import Vue from 'vue';
import Vuetify from 'vuetify';
import VDialog from 'vuetify/lib/components/VDialog';
import VSelect, { defaultMenuProps as vSelectDefaultMenuProps } from 'vuetify/lib/components/VSelect/VSelect';
import 'vuetify/dist/vuetify.min.css';
import ko from 'vuetify/es5/locale/ko';
import en from 'vuetify/es5/locale/en';
import { resolveInitialLocale } from '../utils/localeUtils';
import { readInitialDarkMode } from '../utils/themeStorage';

Vue.use(Vuetify);

Vue.component(
  'v-dialog',
  VDialog.extend({
    props: {
      transition: {
        type: [String, Boolean],
        default: false
      }
    }
  })
);

/**
 * v-select 메뉴: 필드를 덮지 않고 아래로 열림 (전역 기본).
 * - defaultMenuProps를 직접 바꿔 $_menuProps 병합에도 offsetY가 항상 반영됨
 * - full-build 등록분과 동일 모듈을 쓰도록 lib VSelect로 재등록
 * - v-autocomplete / v-combobox는 프레임워크 기본이 이미 offsetY: true
 * - 개별 컴포넌트에서 menu-props="{ offsetY: false }" 로 옵트아웃 가능
 */
vSelectDefaultMenuProps.offsetY = true;
Vue.component('VSelect', VSelect);
Vue.component('v-select', VSelect);

/**
 * Solvit 색 단일 소스 (라이트/다크 themes.* 만 hex·rgba 정의).
 * customProperties → --v-{키}-base (예: rail → --v-rail-base).
 *
 * 디자인 원칙 (스크린샷 피드백 반영)
 * - 크롬은 R≈G≈B 트루 뉴트럴. 쿨 슬레이트(B>R)는 모니터에서 라벤더/보라로 읽힘 → 금지.
 * - primary는 액션·탭 인디케이터만. 헤더/레일 배경에 섞지 않음.
 * - 다크: background↔rail↔surface↔header를 같은 차콜 패밀리로 이어 단차·이질감 제거.
 * - 시맨틱: IR=error, RGB=info.
 */
export default new Vuetify({
  lang: {
    locales: { ko, en },
    current: resolveInitialLocale()
  },
  theme: {
    options: {
      customProperties: true
    },
    dark: readInitialDarkMode(),
    themes: {
      light: {
        primary: '#5C57D1',
        secondary: '#6B7280',
        accent: '#2563EB',
        error: '#DC2626',
        info: '#2563EB',
        success: '#16A34A',
        warning: '#EA580C',
        /* 트루 그레이 — 라벤더 기미 없이 header/rail 대비만 유지 */
        background: '#F0F0F0',
        surface: '#FFFFFF',
        header: '#E6E6E6',
        rail: '#F5F5F5',
        toolbarChrome: '#FAFAFA',
        text: '#171717',
        mapToolIcon: '#525252',
        mapToolIconOnPrimary: '#FFFFFF',
        borderSubtle: '#D6D6D6',
        surfaceDim: '#F7F7F7',
        modalHeader: '#F0F0F0',
        overlayScrim: 'rgba(23, 23, 23, 0.4)',
        appBarShadow: '0 1px 0 rgba(23, 23, 23, 0.07)'
      },
      dark: {
        primary: '#A39EFA',
        secondary: '#A3A3A3',
        accent: '#60A5FA',
        error: '#F87171',
        info: '#60A5FA',
        success: '#4ADE80',
        warning: '#FBBF24',
        /* 트루 차콜 계단 — 네이비/보라 캐스트·순검 단차 제거 */
        background: '#0A0A0A',
        surface: '#171717',
        header: '#262626',
        rail: '#141414',
        toolbarChrome: '#111111',
        text: '#F5F5F5',
        mapToolIcon: '#A3A3A3',
        mapToolIconOnPrimary: '#FAFAFA',
        borderSubtle: '#404040',
        surfaceDim: '#111111',
        modalHeader: '#262626',
        overlayScrim: 'rgba(0, 0, 0, 0.64)',
        appBarShadow: '0 1px 0 rgba(0, 0, 0, 0.45)'
      }
    }
  }
});
